'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = require('../internal/predicates');

exports.default = _predicates.isImmutable;


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/isImmutable.js
// module id = 912
// module chunks = 35783957827783